import type { Currency } from '../../generated-types';

export const numberFormat = (number: number, fractals = 2, locale = 'nb-NO'): string => {
    const formatter = Intl.NumberFormat(locale, { minimumFractionDigits: fractals, maximumFractionDigits: fractals });
    if (fractals === 0) {
        return formatter.format(Math.floor(number));
    }
    return formatter.format(number);
};

export const getCurrency = (currency: Currency) => (currency === 'NOK' ? 'kr' : String(currency)).split('').join('‍');
export const currencyFormatter = (
    number: number | null | undefined,
    currency: Currency = 'NOK',
    fractals = 2,
    locale = 'nb-NO',
    showLocalCurrency = true,
): string => {
    if (typeof number !== 'number') return '';
    const currencyLabel = currency !== 'NOK' || showLocalCurrency ? ` ${getCurrency(currency)}` : '';
    return `${numberFormat(number, fractals, locale)}${currencyLabel}`;
};

type CurrencyFormatOptions = {
    // @default 'NOK'
    currency?: Currency;
    // @default 2
    fractals?: number;
    // @default 'nb-NO'
    locale?: string;
    // @default true
    showLocalCurrency?: boolean;
};

export const formatWithCurrency = (
    number: number | null | undefined,
    { currency, fractals, locale, showLocalCurrency }: CurrencyFormatOptions = {},
) => currencyFormatter(number, currency, fractals, locale, showLocalCurrency);
